import _ from "lodash";
import scrollBarWidth from "Utils/scrollBarWidth";
import { DATA_GRID_CELL_TYPES } from "StandardsTable/modules/constants";

export const getEdgesFromNodeMap = nodeMap => {
  return Array.from(nodeMap.values(), ({ rowId, columns, children }) => ({
    rowId,
    columns,
    children,
  }));
};

export const getDataGridHeaders = ({
  properties,
  columns,
  parentContainerWidth,
  fillColumn,
  isRowMarkersEnabled,
  isAddRowHandlerEnabled,
  actionHandlerFn,
  isDarkHeader,
}) => {
  const headers = _.map(columns, id => {
    const headerConfig = properties[id].headerConfig || {};

    // Pick only defined properties from headerConfig
    const baseHeader = _.pickBy(
      {
        id,
        title: headerConfig.title,
        width: headerConfig.width,
        prefix: headerConfig.prefix,
        tooltip: headerConfig.tooltip,
        toggleAllCheckboxesOnHeaderClick:
          headerConfig.toggleAllCheckboxesOnHeaderClick,
        icon: headerConfig.icon,
        isAlignedToRightEnd: headerConfig.isAlignedToRightEnd,
        iconTooltip: headerConfig.iconTooltip,
        onIconClick: headerConfig.onIconClick,
        iconSize: headerConfig.iconSize,
        styles: headerConfig.styles,
      },
      value => value !== undefined
    );

    // Add special handling for actionType
    if (headerConfig.actionType !== undefined) {
      baseHeader.onIconClick = () => {
        actionHandlerFn({ type: headerConfig.actionType });
      };
    }

    if (isDarkHeader) {
      baseHeader.styles = {
        backgroundColor: "#333",
        color: "#fafafa",
        ...(baseHeader.icon ? { iconColor: "#fafafa" } : {}),
      };
    }

    return baseHeader;
  });

  const viewportWidth = parentContainerWidth - 2 - scrollBarWidth;
  const combinedWidth = _.sumBy(headers, "width");

  if (combinedWidth < viewportWidth) {
    return _.map(headers, header => {
      // Expand the designated “fill” column to take up the allocated width
      if (header.id === fillColumn) {
        return {
          ...header,
          width:
            header.width +
            (viewportWidth -
              combinedWidth -
              (isRowMarkersEnabled ? 40 : 0) -
              (isAddRowHandlerEnabled ? 20 : 0)),
        };
      }
      return header;
    });
  }

  return headers;
};

export const getLoaderData = ({ columns, numberOfRows = 100 }) => {
  return _.map(_.range(0, numberOfRows), i => ({
    rowId: i,
    columns: _.map(columns, () => ({
      cellType: DATA_GRID_CELL_TYPES.SKELETON,
    })),
  }));
};
